/* eslint-disable */
export const redCardIcon = {
  data: `<svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.744568" y="0.0429688" width="8.26389" height="11.8793" rx="2" fill="#FE2E0F"/>
</svg>
`,
  name: 'red-card' as const,
};
